import { api } from "./AxiosInstance";

export const SendOtpApi = async (email, userType) =>
  await api.post(`/employee-connect/authentication?type=${userType}`, {
    email: email,
    is_candidate: true,
  });

export const VerifyOtpApi = async (email, otp) =>
  await api.post("/employee-connect/authentication/otp-verify", {
    email: email,
    otp: otp,
  });

export const LogOutApi = async () =>
  await api.post("/employee-connect/authentication/logout");
